var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "12px",
    viewBox: "0 0 20 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/List") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Administration",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SortFilter/Scoreboard-Controls/V1",
    transform: "translate(-865.000000, -134.000000)",
    fill: "#B7844D"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/List",
    transform: "translate(865.000000, 134.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 2.35294118,
    height: 2.35294118
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 4.70588235,
    width: 2.35294118,
    height: 2.35294118
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 9.41176471,
    width: 2.35294118,
    height: 2.35294118
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 4.70588235,
    y: 0,
    width: 15.2941176,
    height: 2.35294118
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 4.70588235,
    y: 4.70588235,
    width: 15.2941176,
    height: 2.35294118
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 4.70588235,
    y: 9.41176471,
    width: 15.2941176,
    height: 2.35294118
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/List.7079582fb1cf8c53221d3c9a8941ca95.svg";
export { ForwardRef as ReactComponent };